module.exports = __webpack_public_path__ + "img/transparencia_two.2c689df6.png";